// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__C8v2V","content":"RecentSearches_content__wXvyk"};